var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLivrosNaoSelecionados({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#8E58BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9V27M10 9H16C16.5523 9 17 9.44772 17 10V26C17 26.5523 16.5523 27 16 27H10C9.44772 27 9 26.5523 9 26V10C9 9.44772 9.44772 9 10 9ZM26.4 24.9C26.6 25.4 26.3 26 25.8 26.2L23.9 26.9C23.4 27.1 22.8 26.8 22.6 26.3L17.1 11.1C16.9 10.6 17.2 10 17.7 9.8L19.6 9.1C20.1 8.9 20.7 9.2 20.9 9.7L26.4 24.9Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLivrosNaoSelecionados);
export default __webpack_public_path__ + "static/media/iconLivrosNaoSelecionados.e936cd4273b7589becfd3dc8374fc54e.svg";
export { ForwardRef as ReactComponent };